<template>
	<div>
		<el-input v-model="query.telephone" size="small" style="width: 200px;margin-right: 30px;"
			placeholder="一级分销者手机号"></el-input>
		<el-select v-model="query.status" @change="getList()" size="small">
			<el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
		</el-select>
		分享时间
		<el-date-picker v-model="query.time" @change="getList()" type="daterange" size="small"
			style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
			range-separator="至">
		</el-date-picker>
		<span>
			<el-button type="primary" @click="getList(1)" size="small" style="margin-left: 10px;">搜索</el-button>
			<el-button type="primary" size="small" @click="exports">导出</el-button>
		</span>
		<el-table :data="tableData" :cell-style="{'text-align':'center'}" height="70vh"
			:header-cell-style="{ 'background': '#d8d8d8', 'text-align': 'center', color: '#2D2D2D'}"
			style="margin-top: 30px;">
			<el-table-column label="分销人">
				<template slot-scope="scope">
					{{scope.row.firstDist==null?'':scope.row.firstDist.nickName==null?'':scope.row.firstDist.nickName}}
				</template>
			</el-table-column>
			<el-table-column label="分销人ID">
				<template slot-scope="scope">
					{{scope.row.firstDist==null?'':scope.row.firstDist.id==null?'':scope.row.firstDist.id}}
				</template>
			</el-table-column>
			<el-table-column label="分销人手机号">
				<template slot-scope="scope">
					{{scope.row.firstDist==null?'':scope.row.firstDist.telphone==null?'':scope.row.firstDist.telphone}}
				</template>
			</el-table-column>
			<el-table-column label="被分销人">
				<template slot-scope="scope">
					{{scope.row.secondDist==null?'':scope.row.secondDist.nickName==null?'':scope.row.secondDist.nickName}}
				</template>
			</el-table-column>
			<el-table-column label="被分销人ID">
				<template slot-scope="scope">
					{{scope.row.secondDist==null?'':scope.row.secondDist.id==null?'':scope.row.secondDist.id}}
				</template>
			</el-table-column>
			<el-table-column label="订单ID">
				<template slot-scope="scope">
					{{scope.row.order==null?'暂无' : scope.row.order.id}}
				</template>
			</el-table-column>
			<el-table-column label="订单ID">
				<template slot-scope="scope">
					{{scope.row.order==null?'暂无' : scope.row.order.orderNo}}
				</template>
			</el-table-column>
			<el-table-column label="消费服务">
				<template slot-scope="scope">
					{{scope.row.order==null?'暂无' : scope.row.order.type}}
				</template>
			</el-table-column>
			<el-table-column label="消费门店">
				<template slot-scope="scope">
					{{scope.row.order==null?'暂无' : scope.row.order.storeName}}
				</template>
			</el-table-column>
			<el-table-column label="消费总额">
				<template slot-scope="scope">
					{{scope.row.order==null?'':"￥"}}{{scope.row.order==null?'暂无' :scope.row.order.payTotal==null?'0.00':scope.row.order.payTotal}}
				</template>
			</el-table-column>
			<el-table-column label="提成">
				<template slot-scope="scope">
					￥{{ scope.row.order==null?'0.00':(scope.row.money/100).toFixed(2)}}
				</template>
			</el-table-column>
			<el-table-column prop="addTime" label="分享日期"></el-table-column>
			<el-table-column prop="updateTime" label="领取日期"></el-table-column>
		</el-table>
		<div style="text-align: center;">
			<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
				style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.pageNum"
				:total="query.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	import util from './util'
	export default {
		data() {
			return {
				tableData: [],
				query: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
					telephone: '',
					status: 1,
					time:[],
				},
				statusList: [{
						value: 1,
						label: "分销成功"
					},{
						value: 0,
						label: "分销未提成"
					},
				],
				url: url(),
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList(type) {
				if (type == 1) {
					this.query.pageNum = 1
				}
				var a = "?pageNum=" + this.query.pageNum + "&pageSize=" + this.query.pageSize
				if (this.query.telephone != null && this.query.telephone != '') {
					a += "&telephone=" + this.query.telephone
				}
				if (this.query.status != null) {
					a += "&status=" + this.query.status
				}
				if (this.query.time.length>0) {
					a += "&startTime="+this.query.time[0] +"&endTime="+this.query.time[1]
				}
				this.$http.get("dDistRecord/list" + a).then(res => {
					this.tableData = res.body.data
					// for(var a in this.tableData){
					// 	if(this.tableData[a].secondDist==null ||this.tableData[a].secondDist=='' ){
					// 		this.tableData[a].secondDist.nickName=''
					// 		console.log('aaaaaaaaaaaaaaaaaaaaa')
					// 	}

					// }
					this.query.total = res.body.total
					console.log(res)
				})
			},
			exports() {
				let str = "dDistRecord/export?status=" + this.query.status;
				if (this.query.telephone != null && this.query.telephone != '') {
					str += "&telephone=" + this.query.telephone
				}
				else if (this.query.time.length>0 && this.query.time!=null) {
					str += "&startTime="+this.query.time[0] +"&endTime="+this.query.time[1];
					
				}else {
					return this.$message.error("请选择时间范围")
				}
				window.location.assign(this.url + str);
			},
			handleSizeChange(val) {
				this.query.pageSize = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.query.pageNum = val
				this.getList()
			}
		}
	}
</script>

<style>
	.page {
		text-align: center;
	}
</style>